import { Injectable } from '@angular/core';
import { Http, Headers } from '@angular/http';
import { ApplicationUrlSettings } from '../../settings/ApplicationUrlSettings';
import { } from '@angular/common/http';
import { HttpWrapperService } from '../http-wrapper/http-wrapper.service';

@Injectable()
export class CompanyService {

  constructor(private http: HttpWrapperService) { }

  public createCompany(company: any): Promise<string> {
    var url = `${ApplicationUrlSettings.NODE_API_URL}client/company-locations`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.post(url, company, { headers: headers }).toPromise().then(res => res.json());
  }

  updateModel(companyid,model,pricePerKm){
    var payload = {
      companyid:companyid,
      model:model,
      pricePerKm:pricePerKm
    }
    var url = `${ApplicationUrlSettings.NODE_API_URL}client/pricing-model`;
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    return this.http.patch(url, payload, { headers: headers }).toPromise().then(res => res.json());
  }


  loginUser(email, password): Promise<string> {

    var body = {
      "email": email,
      "password": password
    };
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.CLIENT_LOGIN;
    return this.http.post(url, body).toPromise().then(res => res.json());
  }


  public unassignCompanyLocations(clientid,companyid,locationid){
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    var url = `${ApplicationUrlSettings.NODE_API_URL}client/company-locations/unassign?clientid=${clientid}&companyid=${companyid}&locationid=${locationid}`;
    return this.http.delete(url,{ headers: headers }).toPromise().then(res => res.json());
  }


  public assignCompanyLocations(clientid,companyid,locationid){
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    var url = `${ApplicationUrlSettings.NODE_API_URL}client/company-locations/assign?clientid=${clientid}&companyid=${companyid}&locationid=${locationid}`;
    return this.http.post(url, {},{ headers: headers }).toPromise().then(res => res.json());
  }

  public getCompanies() {
    let url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.GET_COMPANY;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  public getClients() {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    let url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.GET_CLIENTS;
    return this.http.get(url, { headers: headers }).toPromise().then(res => res.json());
  }

  public getCompanyTrips(startDate: string, endDate: string) {
    var json = window.localStorage.getItem("login");
    var data = JSON.parse(data);
    let url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.GET_COMPANY_TRIPS}/${data.id}?startDate=${startDate}&endDate=${endDate}`;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  getEmployeeid(company, employeeid) {
    let url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.EMPLOYEE_ID}/${company}/${employeeid}`;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  public getClientById(id) {
    var url = "";
    url = ApplicationUrlSettings.NODE_API_URL + "client?id=" + id;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  public getLocationDestinations(companyid, locationid, ratetype) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}client/destination?companyid=${companyid}&locationid=${locationid}&ratetype=${ratetype}`;
    return this.http.get(url).toPromise().then(res => res.json());
  }


  public getCompanyLocations(companyid) {
    var url = `${ApplicationUrlSettings.NODE_API_URL}${ApplicationUrlSettings.GET_COMPANY}/${companyid}/location`;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  getCompaniesByClientId(id) {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    var url = `${ApplicationUrlSettings.NODE_API_URL}client/company-locations?clientid=${id}`;
    return this.http.get(url, { headers: headers }).toPromise().then(res => res.json());
  }

  public getCompany(clientid = null): Promise<string> {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`      
    });
    var url = `${ApplicationUrlSettings.NODE_API_URL}client/company-locations`;
    if(clientid){
      url += `?clientid=${clientid}`;
    }
    return this.http.get(url, { headers: headers }).toPromise().then(res => res.json());
  }

  public deactivateCompanyLocation(id: any): Promise<string> {
    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.DEACTIVATE_COMP_LOC + "/" + id;
    return this.http.delete(url).toPromise().then(res => res.json());
  }

  public insertCompanyLocations(body: any) {
    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.INSERT_COMPANY_LOC;
    return this.http.post(url, JSON.stringify(body)).toPromise().then(res => res.json());
  }

  public updateCompanyLocations(body: any) {
    var url = ApplicationUrlSettings.NODE_API_URL + "client/company-locations/insert";
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`,     
    });
    return this.http.post(url, body, { headers: headers }).toPromise().then(res => res.json());
  }

  public getDepartments(companyid: number, locationid: number): Promise<string> {
    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.GET_DEPARTMENTS + "/" + companyid + "/" + locationid;
    return this.http.get(url).toPromise().then(res => res.json());
  }

  public saveDepartment(departmentData): Promise<string> {
    var url = ApplicationUrlSettings.PHP_API_URL + ApplicationUrlSettings.GET_DEPARTMENTS;
    return this.http.post(url, JSON.stringify(departmentData)).toPromise().then(res => res.json());
  }


  // creating an post api for changing the status of the company with the header for the token from the local storage

  // Sending the company's data to the api without stringifying the data as it gives error if stringifying the data.
  public changeCompanyStatus(companyData): Promise<string> {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`,     
    });
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.CHANGE_COMPANY_STATUS;
    return this.http.post(url, companyData, { headers: headers }).toPromise().then(res => res.json());
  }

  // want to create an api for deleting the company with the header for the token from the local storage
  public deleteCompany(companyData): Promise<string> {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`,     
    });
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.DELETE_COMPANY;
    return this.http.delete(url, { headers: headers, body: companyData }).toPromise().then(res => res.json());
  }

  // API for updating company information
  public updateCompany(companyData): Promise<string> {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`,
      'Content-Type': 'application/json'     
    });
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.UPDATE_COMPANY + `?id=${companyData.id}`;
    return this.http.post(url, companyData, { headers: headers }).toPromise().then(res => res.json());
  }

  // API for restoring the deleted company
  public restoreCompany(companyData): Promise<string> {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`,     
    });
    var url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.RESTORE_COMPANY;
    return this.http.post(url, companyData, { headers: headers }).toPromise().then(res => res.json());
  }


  /**
   * @param includeDeleted When true, requests soft-deleted administrators from the API (query param; backend must support it).
   */
  public getAdministratorData(includeDeleted: boolean = true) {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    let url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.GET_ADMINISTRATORS_API;
    if (includeDeleted) {
      url += (url.indexOf('?') >= 0 ? '&' : '?') + 'include_deleted=true';
    }
    return this.http.get(url, { headers: headers }).toPromise().then(res => res.json());
  }


  public deleteAdministrator(admin) {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    let url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.DELETE_ADMINISTRATORS_API + `/${admin.id}`;
    return this.http.delete(url, { headers: headers }).toPromise().then(res => res.json());
  }
  public activateDeactivateAdmin(admin) {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    let url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.ACTIVATE_DEACTIVATE_ADMINISTRATORS_API;
    return this.http.post(url, { admin_id: admin.id, active: admin.admin_active? false: true }, { headers: headers }).toPromise().then(res => res.json());
  }

  /** POST main-client/administrator/role — body { admin_id, role_id } replaces admin roles with the single role. */
  public updateAdministratorRole(adminId: number | string, roleId: number | string) {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    const url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.CHANGE_ADMIN_ROLE_API;
    return this.http.post(url, { admin_id: adminId, role_id: roleId }, { headers: headers }).toPromise().then(res => res.json());
  }

  /** POST main-client/administrator/restore/:id */
  public restoreAdmin(admin: { id: number | string }) {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    const id = admin && admin.id != null ? admin.id : '';
    let url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.RESTORE_ADMINISTRATORS_API + '/' + id;
    return this.http.post(url, { id: admin.id }, { headers: headers }).toPromise().then(res => res.json());
  }

  public sendResetPassword(admin) {
    const headers = new Headers({
      'Authorization': `Bearer ${localStorage.getItem('token')}`
    });
    let url = ApplicationUrlSettings.NODE_API_URL + ApplicationUrlSettings.SEND_RESET_PASSWORD_API;
    return this.http.post(url, {admin_id: admin.id, email: admin.email }, { headers: headers }).toPromise().then(res => res.json());
  }
}
